// extracted by mini-css-extract-plugin
export default {"strip":"workflow-strip_strip__e8BN-","step":"workflow-strip_step__7RPfJ","num":"workflow-strip_num__aWs3x","label":"workflow-strip_label__jYX+w"};